import {observable, action} from "mobx"
import {load} from "recaptcha-v3"

import GlobalStore from "../../global/store/GlobalStore"
import RouterStore from "../../global/store/RouterStore"
import config from "../../global/config/settings"

import {login} from "../../global/helpers/actions"

import api from "../../global/actions/api"

class LoginStore {
	@observable screen = this.screens.LOGIN

	token = null
	@observable email = ""

	screens = {
		LOGIN: "login",
		REGISTER: "register",
		FORGOT: "forgot"
	}

	@action registration(form) {
		let req = {}
		// form.values()

		if (form.$("isWithoutRpo").value) {
			req = {
				applicant: form.$("applicant").value,
				company_identifier: form.$("company_identifier").value,
				company_name: form.$("company_name").value,
				confirmation: form.$("confirmation").value,
				email: form.$("email").value,
				solver: form.$("solver").value
			}
		} else {
			req = {
				applicant: form.$("applicant").value,
				company_identifier: form.$("company_identifier").value,
				company_name: form.$("company_name").value,
				confirmation: form.$("confirmation").value,
				email: form.$("email").value,
				solver: form.$("solver").value,
				city_code: form.$("rpo_city").value,
				house_number: form.$("rpo_house_number").value,
				street: form.$("rpo_street").value,
				zip: form.$("rpo_zip").value,
				legal_form_name_ext: form.$("rpo_legal_form").value
			}
		}

		GlobalStore.loading(true, "Prebieha registrácia...")

		load(config.SITE_KEY).then((recaptcha) => {
			recaptcha.execute("client_register").then((recaptchaToken) => {
				api
					.registration(req, recaptchaToken)
					.call()
					.then((res) => {
						if (isSafe(res)) {
							form.reset()
							this.screen = this.screens.LOGIN
							GlobalStore.openConfirmationDialog("xsConfirmRegisterSuccess")
						}
						GlobalStore.loading(false)
					})
			})
		})
	}

	@action registrationFinish(form) {
		const {password} = form.values()

		const req = {
			password: password,
			as_login: true
		}

		GlobalStore.loading(true)

		load(config.SITE_KEY).then((recaptcha) => {
			recaptcha.execute("client_action_consume").then((recaptchaToken) => {
				api
					.registrationFinish(req, this.token, recaptchaToken)
					.call()
					.then((res) => {
						if (isSafe(res) && isNotEmpty(res.login)) {
							login(res.login, password)
						}
					})
			})
		})
	}

	@action resetPassword(form) {
		const req = form.values()

		GlobalStore.loading(true, "Reset password...")

		load(config.SITE_KEY).then((recaptcha) => {
			recaptcha.execute("client_reset_password").then((recaptchaToken) => {
				api
					.resetPassword(req, recaptchaToken)
					.call()
					.then(() => {
						form.reset()
						this.screen = this.screens.LOGIN
						GlobalStore.setNotificationMessage("Žiadosť na zmenu hesla odoslaná", "", "success")
						GlobalStore.loading(false)
					})
			})
		})
	}

	@action resetPasswordFinish(form) {
		const {password} = form.values()

		const req = {
			password: password,
			as_login: true
		}

		GlobalStore.loading(true)

		load(config.SITE_KEY).then((recaptcha) => {
			recaptcha.execute("client_action_consume").then((recaptchaToken) => {
				api
					.registrationFinish(req, this.token, recaptchaToken)
					.call()
					.then((res) => {
						if (isSafe(res)) {
							GlobalStore.setNotificationMessage("Heslo bolo úspešne zmenené", "", "success")
							GlobalStore.loading(false)
							RouterStore.push("/login")
						}
					})
			})
		})
	}
}

var singleton = new LoginStore()
export default singleton

